import styled, { css } from 'vue3-styled-components';

// =============== 수급자 등록 모달 스타일 ===============
export const BeneficiaryModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    animation: fadeIn 0.3s ease-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export const ModalOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BeneficiaryModalContent = styled.div`
    background: white;
    border-radius: 20px;
    width: 95%;
    max-width: 900px;
    height: 85vh;
    max-height: 800px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
        from {
            transform: translateY(50px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

export const BeneficiaryModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    border-bottom: 1px solid #f1f5f9;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a5f72 100%);
    color: white;
    flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
    color: white;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
    padding: 0;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: all 0.2s ease;
    
    &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
    }
`;

export const BeneficiaryModalBody = styled.div`
    padding: 30px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const BeneficiaryModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 20px 30px;
    border-top: 1px solid #f1f5f9;
    background: #fafbfc;
    flex-shrink: 0;
`;

export const FormSection = styled.div`
    margin-bottom: 40px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const SectionTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    margin: 0 0 24px 0;
    padding-bottom: 12px;
    border-bottom: 2px solid #e2e8f0;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 60px;
        height: 2px;
        background: linear-gradient(135deg, #0f4c5c 0%, #fb8b24 100%);
    }
`;

export const SaveButton = styled.button`
    padding: 10px 20px;
    border: none;
    border-radius: 12px;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a5f72 100%);
    color: white;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover:not(:disabled) {
        transform: translateY(-2px);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

export const CancelButton = styled.button`
    padding: 10px 20px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    background: white;
    color: #6b7280;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
        border-color: #d1d5db;
        background: #f9fafb;
        color: #374151;
    }
`;

// 검색 섹션 스타일
export const SearchSection = styled.div`
    margin-bottom: 24px;
    padding: 20px;
    background: #f8fafc;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
`;

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;
    
    &:last-child {
        margin-bottom: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }
`;

export const SearchGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const SearchLabel = styled.label`
    font-weight: 600;
    color: #374151;
    font-size: 14px;
    min-width: 80px;

    @media (max-width: 768px) {
        min-width: auto;
        margin-bottom: 4px;
    }
`;

export const SearchInput = styled.input`
    padding: 10px 12px;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.2s ease;
    flex: 1;
    max-width: 300px;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
    }
    
    &::placeholder {
        color: #9ca3af;
    }

    @media (max-width: 768px) {
        max-width: none;
    }
`;

export const SearchButton = styled.button`
    padding: 9px 10px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    
    &:hover {
        background: #1a5f72;
        transform: translateY(-1px);
    }
`;

export const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const FilterChips = styled.div`
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
`;

const chipProps = css`
    ${props => props.active && css`
        background: #0f4c5c;
        color: white;
        border-color: #0f4c5c;
    `}
`;

export const FilterChip = styled.div`
    padding: 6px 12px;
    border: 2px solid #e5e7eb;
    border-radius: 16px;
    background: white;
    color: #374151;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.2s ease;
    ${chipProps}
    
    &:hover {
        border-color: #0f4c5c;
    }
`;

// 테이블 스타일
export const BeneficiaryTableContainer = styled.div`
    margin-bottom: 20px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e5e7eb;
    max-height: 400px;
    overflow-y: auto;

    /* 커스텀 스크롤바 */
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f5f9;
    }

    &::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 3px;
        
        &:hover {
            background: #94a3b8;
        }
    }
`;

export const BeneficiaryTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    background: white;
    
    th {
        background: #f8fafc;
        padding: 12px 16px;
        text-align: center;
        border-bottom: 2px solid #e5e7eb;
        font-weight: 600;
        color: #374151;
        font-size: 14px;
        white-space: nowrap;
        position: sticky;
        top: 0;
        z-index: 1;
    }
    
    td {
        padding: 12px 16px;
        text-align: center;
        border-bottom: 1px solid #f1f5f9;
        color: #1e293b;
        font-size: 14px;
    }
    
    tbody tr {
        cursor: pointer;
        
        &:hover {
            background: #f8fafc;
        }
        
        &.selected {
            background: #e0f2fe;
            border-left: 4px solid #0f4c5c;
        }
    }
`;

export const ClientName = styled.div`
    font-weight: 600;
    color: #1e293b;
`;

export const BenefitTypeChip = styled.span`
    display: inline-block;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    
    ${props => {
        switch (props.type) {
            case '일반':
                return css`
                    background: #dcfce7;
                    color: #166534;
                `;
            case '기초':
            case '산소':
                return css`
                    background: #fecaca;
                    color: #991b1b;
                `;
            case '감경':
            case '당뇨':
                return css`
                    background: #fef3c7;
                    color: #92400e;
                `;
            case '의료급여':
            case '보장구':
                return css`
                    background: #dbeafe;
                    color: #1e40af;
                `;
            default:
                return css`
                    background: #f1f5f9;
                    color: #475569;
                `;
        }
    }}
`;

export const ContactInfo = styled.div`
    font-size: 13px;
    
    div {
        margin-bottom: 2px;
        
        &:last-child {
            margin-bottom: 0;
        }
    }
`;

// 로딩 및 빈 상태
export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 20px;
`;

export const LoadingSpinner = styled.div`
    font-size: 16px;
    color: #666;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
`;

export const EmptyIcon = styled.div`
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
`;

export const EmptyMessage = styled.h3`
    font-size: 16px;
    color: #374151;
    margin-bottom: 8px;
`;

export const EmptySubMessage = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin: 4px 0;
`;

// 페이지네이션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const PaginationButton = styled.button`
    padding: 6px 8px;
    border: 1px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    
    &:hover:not(:disabled) {
        border-color: #0f4c5c;
        color: #0f4c5c;
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const paginationNumberProps = css`
    ${props => props.active && css`
        background: #0f4c5c;
        color: white;
        border-color: #0f4c5c;
    `}
`;

export const PaginationNumber = styled.button`
    min-width: 32px;
    height: 32px;
    padding: 0 8px;
    border: 1px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    ${paginationNumberProps}
    
    &:hover:not(:disabled) {
        border-color: #0f4c5c;
    }
`;